<template>
  <router-view />
  <GlobalSuccessDialog />
</template>

<script>
// import AuthService from "./modules/auth/views/authService";
import GlobalSuccessDialog from "./components/GlobalSuccessDialog.vue";

export default {
  name: "MainPage",

  components: { GlobalSuccessDialog },

  data() {
    return {
      screenSize: "",
    };
  },

  computed: {},

  mounted() {

    this.checkScreenSize(); // Check screen size initially
    window.addEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      const isSmallScreen = window.matchMedia("(max-width: 768px)").matches;
      this.screenSize = isSmallScreen ? "Small" : "Large";

    },

    // ROT13 function
    // rot13(str) {
    //   return str.replace(/[a-zA-Z]/g, function (c) {
    //     return String.fromCharCode(
    //       (c <= 'Z' ? 90 : 122) >= (c = c.charCodeAt(0) + 13) ? c : c - 26
    //     );
    //   });
    // },

    // Decrypt function
    // decrypt(ciphertext) {
    //   const base64 = rot13(ciphertext);
    //   const decoded = atob(base64);
    //   const parts = decoded.split('|');
    //   return parts[0];
    // }


  },

  watch: {},
};
</script>

<style>
/* @import url("./style.css"); */
</style>
